<script setup lang="ts">
import { QuizType } from '@/enums/quiz.enums';
import { ActivityEvents } from '~/enums/tracking/tracking-events.enums';

const {
  currentAttempt,
  isLoading,
  quiz,
  onQuizFinished,
} = useQuizStore();

const {
  course,
  getChapterByActivity,
} = useCourseState();

const { dispatchTrackingEvent } = useTracking();

const {
  isStarted,
  isFinished,
} = toRefs(currentAttempt.value);

const isMasteryQuiz = computed(() => quiz.value?.type === QuizType.Mastery);
const chapter = computed(() => {
  if (!quiz.value?.quizId) {
    return null;
  }

  return getChapterByActivity(quiz.value.quizId as string);
});

onQuizFinished(() => {
  trackQuizCompleted();
});

const trackQuizCompleted = () => {
  if (!quiz.value || !chapter.value || !course.value) {
    return;
  }

  let activityType: ActivityEvents;

  switch (quiz.value.type) {
    case QuizType.Kickoff:
      activityType = ActivityEvents.KickoffQuizCompleted;
      break;
    case QuizType.Mastery:
      activityType = ActivityEvents.MasteryQuizCompleted;
      break;
    default:
      activityType = ActivityEvents.QuizCompleted;
  }

  dispatchTrackingEvent(activityType, {
    quiz_name: quiz.value.title,
    quiz_id: quiz.value.quizId,
    chapter_name: chapter.value.title,
    course_name: course.value.courseTitle,
    course_id: course.value.id,
    type: course.value.type,
    duration: quiz.value.questions.length || 0,
    score: currentAttempt.value.score,
  });
};

</script>

<template>
  <div
    v-if="isLoading"
    class="flex items-center justify-center h-full"
  >
    <Loader />
  </div>

  <template v-else>
    <QuizIntroMessage v-if="!isStarted" />
    <QuizQuestion v-if="isStarted && !isFinished" />
    <QuizResult v-if="isFinished && !isMasteryQuiz" />
  </template>
</template>